import { render, staticRenderFns } from "./proxyEmployeeInfo.vue?vue&type=template&id=684abdf3&scoped=true"
import script from "./proxyEmployeeInfo.vue?vue&type=script&lang=js"
export * from "./proxyEmployeeInfo.vue?vue&type=script&lang=js"
import style0 from "./proxyEmployeeInfo.vue?vue&type=style&index=0&id=684abdf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684abdf3",
  null
  
)

export default component.exports